<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.vendor') }}
            <template v-if="ready">
              >
              {{ vendor.vendor_name }}
            </template>
          </div>
        </div>
        <div class="col-md-8 right">
          <div
            v-if="vendor !== null"
            class="action">
            <div
              v-if="showOptionButton"
              class="dropdown item">
              <button
                id="dropdownMenuButton"
                class="btn no-bg dropdown-toggle text-secondary shake"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-cog"/>
                <span class="name">{{ $t('button.options') }}</span>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenuButton">
                <a
                  v-if="hasRoleDelete"
                  class="dropdown-item"
                  @click="openConfirmdeleteModal()">
                  <i class="fas fa-trash text-danger"/>
                  <span class="text-danger">{{ $t('button.delete') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.vendor')+' / '+$t('message.partner')"/>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.storecompanyperson') }} *</label>
                    <input
                      ref="name"
                      :class="[bindClass.name]"
                      :disabled="disabledForm"
                      v-model="form.name"
                      type="text"
                      class="form-control"
                      @keyup="onKeyupName">
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.address') }}</label>
                    <textarea
                      :placeholder="$t('placeholder.dotted')"
                      v-model="form.address"
                      :disabled="disabledForm"
                      class="form-control"
                      style="min-height: 70px"/>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.taxpayerno') }}</label>
                    <input
                      v-model="form.tax_id"
                      :disabled="disabledForm"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.contactsandnote')"/>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.tel') }}</label>
                    <input
                      ref=""
                      v-model="form.tel"
                      :disabled="disabledForm"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.email') }}</label>
                    <input
                      ref=""
                      v-model="form.email"
                      :disabled="disabledForm"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.note') }}</label>
                    <textarea
                      :placeholder="$t('placeholder.dotted')"
                      v-model="form.note"
                      :disabled="disabledForm"
                      class="form-control"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          v-if="!disabledForm"
          class="action-bar"
        >
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              class="btn btn-web"
              @click="update()">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" disabled>{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>
    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pricesModalTitle"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog "
        role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            style="border-bottom: none;">
            <h5 class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  name: 'ContactVendorEdit',
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      ready: false,

      form: {
        name: '',
        address: '',
        tax_id: '',
        email: '',
        tel: '',
        note: '',
      },

      originalForm: null,

      bindClass: {
        name: null,
      },

      isSubmitted: false,
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      vendor: 'getVendor',
      getPartnerContact: 'getPartnerContact',
      getPartnerContactIdByPlatform: 'getPartnerContactIdByPlatform',
    }),
    isValidForm () {
      if (this.form.name.trim().length == 0) {
        this.bindClass.name = 'is-invalid'
        return false
      } else {
        this.bindClass.name = null
        return true
      }
    },
    dataSetUpdate () {
      let dataSet = {}
      let vendor = this.vendor
      let form = this.form

      if (!vendor) {
        return null
      }

      let vendorContact = this.getPartnerContact(vendor.contacts)

      form.address = form.address == null ? '' : form.address
      form.note = form.note == null ? '' : form.note

      dataSet['vendor_id'] = vendor.vendor_id
      dataSet['name'] = !form.name ? null : form.name.trim()
      dataSet['address'] = !form.address ? null : form.address.trim()
      dataSet['tax_id'] = !form.tax_id ? null : form.tax_id.trim()
      dataSet['note'] = !form.note ? null : form.note.trim()
      dataSet['contacts'] = {
        'insert': [],
        'update': [],
        'delete': [],
      }

      if (vendorContact.email == null) {
        if (form.email !== vendorContact.email) {
          if (form.email.trim().length > 0) {
            dataSet['contacts'].insert.push({
              'platform': 'email',
              'source': form.email,
            })
          }
        }
      } else {
        if (form.email !== vendorContact.email) {
          if (form.email.trim().length > 0) {
            dataSet['contacts'].update.push({
              'contact_id': this.getPartnerContactIdByPlatform('email', vendor.contacts),
              'platform': 'email',
              'source': form.email,
            })
          } else {
            dataSet['contacts'].delete.push({
              'contact_id': this.getPartnerContactIdByPlatform('email', vendor.contacts),
            })
          }
        }
      }

      if (vendorContact.tel == null) {
        if (form.tel !== vendorContact.tel) {
          if (form.tel.trim().length > 0) {
            dataSet['contacts'].insert.push({
              'platform': 'tel',
              'source': form.tel,
            })
          }
        }
      } else {
        if (form.tel !== vendorContact.tel) {
          if (form.tel.trim().length > 0) {
            dataSet['contacts'].update.push({
              'contact_id': this.getPartnerContactIdByPlatform('tel', vendor.contacts),
              'platform': 'tel',
              'source': form.tel,
            })
          } else {
            dataSet['contacts'].delete.push({
              'contact_id': this.getPartnerContactIdByPlatform('tel', vendor.contacts),
            })
          }
        }
      }

      return dataSet
    },
    disabledForm () {
      return !this.hasRoleEdit
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
      // dataTable option
      let option = this.dataTableOption()
      // set dataTable
      setTimeout(() => { $('#dataTable').DataTable(option) }, 1)
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    /**
     *  validation
     */
    if (!this.$route.query.ven_id) {
      return this.$router.push({ name: 'ContactVendorAll' })
    }
    // get vendor
    let res = await this.$store.dispatch('getVendor', {
      vendor_id: this.$route.query.ven_id,
    })
    if (!res.success) {
      return this.$router.push({ name: 'ContactVendorAll' })
    }
    if (res.data.length == 0) {
      return this.$router.push({ name: 'ContactVendorAll' })
    }
    /**
     *  validation success
     */
    // set form
    this.form.name = this.vendor.vendor_name
    this.form.gender = this.vendor.gender
    this.form.birthdate = new Date(this.vendor.birthdate)
    this.form.address = this.vendor.address
    this.form.tax_id = this.vendor.tax_id
    for (let i in this.vendor.contacts) {
      let item = this.vendor.contacts[i]
      if (item.platform == 'email') {
        this.form.email = item.source
      }
      if (item.platform == 'tel') {
        this.form.tel = item.source
      }
    }
    this.form.note = this.vendor.note,
    // set original form
    this.originalForm = this.getObject(this.form)
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.contacts.title'),
      current: {
        app_name: 'contacts',
        app_id: 11,
        module_id: 3,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 2, [{
      'name': this.$route.query.ven_name,
      'router': {
        'name': 'ContactVendorEdit',
        'query': {
          ven_id: this.$route.query.ven_id,
          ven_name: this.$route.query.ven_name,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 2,
      submenuAtIdx: 2,
    })
  },
  mounted: function () {
    // set popup modal
    this.setModal('#confirmdeleteModal')
  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearVendor'])
  },
  methods: {
    async update (option = {}) {
      if (!this.isValidForm) {
        this.$refs.name.focus()
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      this.isSubmitted = true

      let res = await this.$store.dispatch('updateVendor', this.dataSetUpdate)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.dataSetUpdate.name }),
          color: 'success',
          icon: 'cloud',
        })
        // get products
        await this.$store.dispatch('getVendor', {
          vendor_id: this.vendor.vendor_id,
        })
        // set original form
        this.originalForm = this.getObject(this.form)
        this.isSubmitted = false
        // set sidebar ui
        sidebarModule.init(this.getObject(require('../sidebar.json')))
        sidebarModule.update(this.sidebar, 2, [{
          'name': this.vendor.vendor_name,
          'router': {
            'name': 'ContactVendorEdit',
            'query': {
              ven_id: this.vendor.vendor_id,
              ven_name: this.vendor.vendor_name,
            },
          },
          'activeClass': 'active',
        }], {
          sidebarAtIdx: 2,
          submenuAtIdx: 2,
        })
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    async del () {
      let data = {
        vendor_id: this.vendor.vendor_id,
      }

      let res = await this.$store.dispatch('deleteVendor', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.vendor.vendor_name }),
          color: 'danger',
          icon: 'delete',
        })
        // close modal
        this.closeConfirmdeleteModal()
        // go to ContactVendorAll page
        return this.$router.push({ name: 'ContactVendorAll' })
      }
    },
    onKeyupName () {
      this.isValidForm
    },
    clearForm () {
      this.form = this.getObject(this.originalForm)
      this.form.birthdate = new Date(this.originalForm.birthdate)
    },
    openConfirmdeleteModal () {
      // open modal
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/contact/vendor/Edit.vue